import { get, apiPrefix } from './common';
const getReimbursementHistory = () => {
    return get(`${apiPrefix}/AchReimbursementHistory`);
};
export { getReimbursementHistory };
